module.exports = __webpack_public_path__ + "img/rock-big-09.30c3c085.png";